export const CONTACT_EMAIL = "info@teckube.io";

export const PHONE_DISPLAY = "+1 (833) 832-5823";
export const PHONE_TEL = "+18338325823";

export const SOCIAL_LINKS = [
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/teckube" },
  { id: "x", label: "X", href: "https://x.com/TecKube_", handle: "@TecKube_" },
];

export const mailto = (subject) =>
  `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;

export const NAV_LINKS = [
  { label: "Services", to: "/services" },
  { label: "Academy", to: "/academy" },
  { label: "About", to: "/about" },
];

export const MARQUEE_ITEMS = [
  "Cloud & DevOps",
  "Containerization",
  "Orchestration",
  "Kubernetes",
  "Red Hat OpenShift",
  "Web Applications",
  "Mobile Applications",
  "Custom APIs",
  "Cybersecurity",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const SERVICES = [
  {
    slug: "cloud-devops",
    title: "Cloud & DevOps",
    icon: "cloud",
    tagline: "Build a cloud environment that supports your applications and your team.",
    intro:
      "We help businesses plan cloud migrations, manage infrastructure across cloud platforms and automate software delivery. Our focus is on making environments easier to operate and releases more consistent.",
    points: [
      "Plan and carry out cloud migrations",
      "Manage infrastructure across cloud platforms",
      "Automate software delivery from commit to release",
      "Make environments easier to operate and releases more consistent",
    ],
    image:
      "https://images.unsplash.com/photo-1584169417032-d34e8d805e8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "containerization",
    title: "Containerization & Orchestration",
    icon: "boxes",
    tagline: "Run and manage containerized applications with Kubernetes and Red Hat OpenShift.",
    intro:
      "We help businesses adopt container platforms, organize application deployments and manage the infrastructure supporting their workloads.",
    points: [
      "Adopt container platforms such as Kubernetes and Red Hat OpenShift",
      "Organize application deployments across environments",
      "Manage the infrastructure supporting your workloads",
      "Run containerized applications reliably at scale",
    ],
    image:
      "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "web-mobile-app",
    title: "Web & Mobile Application Development",
    icon: "app",
    tagline: "Turn business requirements into useful digital products.",
    intro:
      "We develop web and mobile applications, with custom APIs to connect applications, data and existing systems. Our approach considers how the product will be used, deployed and maintained.",
    points: [
      "Develop web and mobile applications",
      "Build custom APIs that connect applications, data and existing systems",
      "Design around how the product will actually be used",
      "Plan for deployment and maintenance from the start",
    ],
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    slug: "cybersecurity",
    title: "Cybersecurity",
    icon: "shield",
    tagline:
      "Understand your security needs and strengthen the systems your business depends on.",
    intro:
      "We help businesses identify security gaps and improve protection across applications and infrastructure, with attention to their operating environment and priorities.",
    points: [
      "Identify security gaps across applications and infrastructure",
      "Improve protection where your business needs it most",
      "Work with attention to your operating environment and priorities",
      "Strengthen the systems your business depends on",
    ],
    image:
      "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const ACADEMY_IMAGE =
  "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1603201667141-5a2d4c673378?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const ACADEMY_DISCIPLINES = ["Cloud Computing", "DevOps", "Cybersecurity"];

export const OFFICES = [
  {
    id: "usa",
    country: "United States",
    hq: true,
    lines: ["228 Hamilton Ave, 3rd Floor,", "Palo Alto, California 94301"],
  },
  {
    id: "uae",
    country: "United Arab Emirates",
    hq: false,
    lines: ["Technohub 1, DTEC Dubai", "Silicon Oasis Dubai"],
  },
  {
    id: "nigeria",
    country: "Nigeria",
    hq: false,
    lines: ["The Waterside, 5 Admiralty Rd,", "off Admiralty Way, Lekki Phase 1,", "Lagos, Nigeria 101224"],
  },
];
